import MenuTab, { MenuTabItem } from '@components/MenuTab'
import Scroller from '@components/Scroller'
import map from 'lodash/map'
import * as React from 'react'
import { DetailTabsProp } from './interface'
import menu from './menu'
import { ContentBox, Link, MenuTabBox, StyledGrid } from './style'

const DetailTabs: React.FC<DetailTabsProp> = ({ children, activeTab = 1, withSidebar = false, role = 'full' }) => {
  const [at, setAt] = React.useState(activeTab)
  const filteredChildren = React.Children.toArray(children).filter(c => !!c && c.props.tab === at)

  return (
    <StyledGrid role={role} activeTab={at} fluid withSidebar={withSidebar}>
      <Scroller>
        <MenuTabBox>
          <MenuTab activeTab={at}>
            {map(menu[role], item => (
              <MenuTabItem key={item.tab}>
                <Link active={item.tab === at} onClick={() => setAt(item.tab)}>
                  {item.child}
                </Link>
              </MenuTabItem>
            ))}
          </MenuTab>
        </MenuTabBox>
      </Scroller>

      <ContentBox>{filteredChildren}</ContentBox>
    </StyledGrid>
  )
}

export default DetailTabs
